import { TableRowProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { SxProps } from '@mui/system';
import { StyledGridCustomRow, StyledGridCustomCell } from './row.styles';

export function CfDataGridCustomRow(props: {
  content: ReactNode;
  tableRowSxProps?: SxProps<Theme>;
  tableRowProps?: TableRowProps;
}): JSX.Element {
  return (
    <StyledGridCustomRow className='CfTableRow-custom' sx={props.tableRowSxProps} {...props.tableRowProps}>
      <StyledGridCustomCell>{props.content}</StyledGridCustomCell>
    </StyledGridCustomRow>
  );
}
